import { createContext, useContext } from 'react';
import { UserEstatesQueryActions } from '../../domain';
import { GqlUserEstatesQueryActions } from '../graphql/adapters/gql-user-estates-query.actions';

type UserEstatesActionsContextT = {
  userEstatesQueryActions: UserEstatesQueryActions;
};

export const userEstatesActionsValue: UserEstatesActionsContextT = {
  userEstatesQueryActions: GqlUserEstatesQueryActions,
};

export const UserEstatesActionsContext = createContext<UserEstatesActionsContextT>(userEstatesActionsValue);

export const useUserEstatesActions = (): UserEstatesActionsContextT => useContext(UserEstatesActionsContext);
